import { Button, Collapse, Form, InputNumber, Modal, notification, Radio, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  createAppealAction,
  AppealStateInterface,
  deleteAppealAction,
  i18n,
  StoreStateInterface,
  updateAppealAction,
  DecisionStateInterface,
  clearAppealListAction,
  getSingleDecisionAction,
  getAllAppealsAction,
  TagScreenStateInterface,
  getScreenTagsByTypeAction,
} from '../../../../../../../common';
import { ExclamationCircleOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { AdminRoutes } from '../../../../../_router/admin.routes';
import { useDispatch, useSelector } from 'react-redux';
import TextArea from 'antd/lib/input/TextArea';

const { confirm } = Modal;

const { Panel } = Collapse;

interface Props {
  setTabSummary?: () => void;
}

function DKOMAppealsCrudPageComponent({ setTabSummary }: Props) {

  const dispatch = useDispatch();
  const [form] = Form.useForm<any>();
  const decision: DecisionStateInterface = useSelector((state: StoreStateInterface) => state.decision);
  const data: AppealStateInterface = useSelector((state: StoreStateInterface) => state.appeal);
  const tags: TagScreenStateInterface = useSelector((state: StoreStateInterface) => state.tagScreen);

  useEffect(() => {
    dispatch(getScreenTagsByTypeAction('decision_appeal_response'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decision.currentDecision, data.currentAppeal, data.revision]);

  useEffect(() => {
    form.resetFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, tags]);

  const loadData = () => {
    dispatch(getAllAppealsAction(undefined, `filter[decision.id]=${decision.currentDecision!.id}`, 'sort=id', `page[limit]=9999`));
  }

  const onFinishAppeal = (values: any) => {
    values.appeals.forEach((value: any, index: number) => {
      let appealTags: Array<{ id: number; type: string }> = [];
      appealTags = decision.currentDecision?.attributes?.tagIds?.map((id) => ({
        id: id,
        type: 'tag',
      })) as Array<{ id: number; type: string }>;
      if (value?.dkomRatingFilter) appealTags?.push({ id: value.dkomRatingFilter, type: 'tag' });
      let appealData: any = {
        data: {
          type: 'decision_appeal_response',
          id: data.appeals?.data[index]?.id,
          attributes: {
            explanationPage: value?.explanationPage ? value.explanationPage : 1,
            titleContent: value?.titleContent,
            textContent: value?.textContent,
            dkomText: value?.dkomText,
            lawArticle: value?.lawArticle,
            dkomAssessment: value?.dkomAssessment,
            appealAllegation: value?.appealAllegation,
          },
          relationships: {
            decision: {
              data: {
                id: decision.currentDecision?.id,
                type: 'decision',
              },
            },
            tags: {
              data: appealTags,
            },
          },
        },
      };
      
      !appealData?.data?.id
        ? dispatch(createAppealAction(appealData, values?.appeals.length == index + 1))
        : dispatch(updateAppealAction(appealData, values?.appeals?.length == index + 1));
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(() => {
      setTab();
    }, 2000);
  };

  const onFinishAppealFailed = (errorInfo: any) => {
    notification['error']({ message: i18n.translate('genericFormMsg.pleaseCheck'), duration: 2 });
    console.log('Failed:', errorInfo);
  };

  const loadInitialValues = () => {
    let values: any = data.appeals?.data?.map((appeal) => ({
      explanationPage: appeal?.attributes?.explanationPage,
      titleContent: appeal?.attributes?.titleContent,
      textContent: appeal?.attributes?.textContent,
      dkomText: appeal?.attributes?.dkomText,
      appealAllegation: appeal?.attributes?.appealAllegation,
      lawArticle: appeal?.attributes?.lawArticle,
      dkomAssessment: appeal?.attributes?.dkomAssessment,
      dkomRatingFilter: loadDkomRatingFilter(appeal?.id as number),
    }));

    return values;
  };

  const loadDefaultValues = () => {
    let values: any = [];

    return values;
  };

  const showConfirm = (key: number) => {
    confirm({
      title: i18n.t('appeals.confirmDelete'),
      icon: <ExclamationCircleOutlined />,
      content: i18n.t('common.cantUndo'),
      okText: i18n.t('genericButtons.yes'),
      cancelText: i18n.t('genericButtons.cancel'),
      onOk() {
        dispatch(deleteAppealAction(data.appeals?.data[key]?.id as number));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    });
  };

  const clearAppealList = () => {
    dispatch(clearAppealListAction());
  };

  const addAppeal = () => {
    let appealTags: Array<{ id: number; type: string }> = [];
    appealTags = decision.currentDecision?.attributes?.tagIds?.map((id) => ({
      id: id,
      type: 'tag',
    })) as Array<{ id: number; type: string }>;
    let appealData: any = {
      data: {
        type: 'decision_appeal_response',
        attributes: {
          explanationPage: 1,
          titleContent: '',
          textContent: '',
          dkomText: '',
          lawArticle: '',
          dkomAssessment: '',
          appealAllegation: '',
        },
        relationships: {
          decision: {
            data: {
              id: (decision.currentDecision?.id as number),
              type: 'decision',
            },
          },
          tags: {
            data: appealTags,
          },
        },
      },
    };

    dispatch(createAppealAction(appealData));
  };

  const setTab = () => {
    setTabSummary && setTabSummary();
  };

  const loadDkomRatingFilter = (id: number) => {
    const tagTrue = getDkomRatingFilterTrue()?.tag?.id;
    const tagFalse = getDkomRatingFilterFalse()?.tag?.id;
    const appeal = data.appeals?.data?.find((appeal) => appeal.id == id);
    let tagFoundTrue;
    let tagFoundFalse;
    if (tagTrue && appeal) {
      if (appeal.attributes?.tagIds?.includes(tagTrue)) tagFoundTrue = tagTrue;
    }
    if (tagFalse && appeal) {
      if (appeal.attributes?.tagIds?.includes(tagFalse)) tagFoundFalse = tagFalse;
    }
    return tagFoundTrue ? tagFoundTrue : tagFoundFalse;
  };

  const getDkomRatingFilterTrue = () => {
    const tag = tags.tagScreens?.find((tag) => tag.filter.name == 'Ocjena DKOM-a');
    let child;
    if (tag && tag?.children && tag?.children?.length && tag?.children[0]) {
      child = tag?.children[0];
    }
    return child;
  };

  const getDkomRatingFilterFalse = () => {
    const tag = tags.tagScreens?.find((tag) => tag.filter.name == 'Ocjena DKOM-a');
    let child;
    if (tag && tag?.children && tag?.children?.length && tag?.children[1]) {
      child = tag?.children[1];
    }
    return child;
  };

  const genExtra = (key: number) => <DeleteOutlined onClick={() => showConfirm(key)} className="button" />;

  return (
    <div className="dkomAppealsCrud w100-h100">
      {(
        <Form
          form={form}
          layout="vertical"
          name="appeal"
          size="large"
          scrollToFirstError
          onFinish={onFinishAppeal}
          onFinishFailed={onFinishAppealFailed}
          autoComplete="off"
          requiredMark={false}
        >
          <div className="dkomAppealsCrud__form">
            <Form.List
              initialValue={loadInitialValues()}
              name="appeals"
            >
              {(fields) => (
                <Collapse defaultActiveKey={'Panel0'}>
                  {fields.map(({ key, name }) => (
                    <Panel header={`${key + 1}. Odgovor na žalbu`} key={'Panel' + key} extra={genExtra(key)}>
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          width: '100%',
                          marginBottom: 8,
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          label={
                            <span className="text-bold">{i18n.translate(`appeals.form.fields.titleContent`)}</span>
                          }
                          name={[name, 'titleContent']}
                          rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <TextArea autoSize={{ minRows: 4 }} />
                        </Form.Item>
                        <Form.Item
                          label={<span className="text-bold">{i18n.translate(`appeals.form.fields.textContent`)}</span>}
                          name={[name, 'textContent']}
                          rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <TextArea autoSize={{ minRows: 4 }} />
                        </Form.Item>
                        <Form.Item
                          label={<span className="text-bold">{i18n.translate(`appeals.form.fields.dkomText`)}</span>}
                          name={[name, 'dkomText']}
                          //rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <TextArea autoSize={{ minRows: 4 }} />
                        </Form.Item>
                        <Form.Item
                          label={
                            <span className="text-bold">{i18n.translate(`appeals.form.fields.appealAllegation`)}</span>
                          }
                          name={[name, 'appealAllegation']}
                          //rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <TextArea autoSize={{ minRows: 4 }} />
                        </Form.Item>
                        <Form.Item
                          label={<span className="text-bold">{i18n.translate(`appeals.form.fields.lawArticle`)}</span>}
                          name={[name, 'lawArticle']}
                          //rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <TextArea autoSize={{ minRows: 4 }} />
                        </Form.Item>
                        <Form.Item
                          label={
                            <span className="text-bold">{i18n.translate(`appeals.form.fields.dkomAssessment`)}</span>
                          }
                          name={[name, 'dkomAssessment']}
                          //rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                        >
                          <TextArea autoSize={{ minRows: 4 }} />
                        </Form.Item>
                        <Form.Item
                          label={
                            <span className="text-bold">{i18n.translate(`appeals.form.fields.explanationPage`)}</span>
                          }
                          name={[name, 'explanationPage']}
                          //rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 12 }}
                        >
                          <InputNumber min={1} />
                        </Form.Item>

                        <div style={{ marginTop: 16 }} className="subtitle">
                          <span className="text">{i18n.translate('appeals.form.sections.filters')}</span>
                        </div>

                        <Form.Item
                          label={
                            <span className="text-bold">{i18n.translate(`appeals.form.fields.dkomRatingFilter`)}</span>
                          }
                          name={[name, 'dkomRatingFilter']}
                          //rules={[{ required: true, message: i18n.translate(`genericFormMsg.required`) }]}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 12 }}
                        >
                          <Radio.Group>
                            <Radio.Button
                              value={getDkomRatingFilterTrue()?.tag?.id ? getDkomRatingFilterTrue()?.tag?.id : 0}
                            >
                              {getDkomRatingFilterTrue()?.tag?.name ? getDkomRatingFilterTrue()?.tag?.name : ''}
                            </Radio.Button>
                            <Radio.Button
                              value={getDkomRatingFilterFalse()?.tag?.id ? getDkomRatingFilterFalse()?.tag?.id : 1}
                            >
                              {getDkomRatingFilterFalse()?.tag?.name ? getDkomRatingFilterFalse()?.tag?.name : ''}
                            </Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                      </Space>
                    </Panel>
                  ))}
                </Collapse>
              )}
            </Form.List>
            <Button style={{ marginTop: 16 }} type="link" onClick={() => addAppeal()} block icon={<PlusOutlined />}>
              {i18n.translate(`appeals.crudTitleAdd`)}
            </Button>
          </div>
          <div className="dkomAppealsCrud__bottomButtons">
            <div></div>
            <div>
              <Link to={AdminRoutes.DKOM_DECISIONS.fullPath} key={AdminRoutes.DKOM_DECISIONS.path}>
                <Button
                  onClick={clearAppealList}
                  className="button"
                  size="large"
                  style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193, marginRight: 16 }}
                >
                  {i18n.translate('genericButtons.cancel')}
                </Button>
              </Link>
              <Button
                className="button"
                htmlType="submit"
                type="primary"
                size="large"
                style={{ fontSize: 16, fontWeight: 700, borderRadius: 0, minWidth: 193 }}
              >
                {i18n.translate('genericButtons.save')}
              </Button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
}

export default DKOMAppealsCrudPageComponent;
